// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3BMLA","right":"styles_right__1CW_O"};